<template>
  <div style="width:100%;">
    <div
        style="position: fixed;top: 0px;z-index: 999;width: 100%;;height: 220px;background-color:#258BF0;color: white;">
      <div style="text-align:center;line-height: 40px;margin-top: 20px;font-size: 26px;">{{ data.customerName }}</div>
      <div style="text-align:center">{{ data.code }}</div>
      <div style="display: flex;justify-content: center;text-align: center;">
        <div style="padding: 0 20px;margin: 10px 0;border-right: 1px solid white;">
          <div><span style="font-size: 20px;">{{ data.propertyArea }}</span>㎡</div>
          <div style="font-size: 14px;">租赁面积</div>
        </div>
        <div style="padding: 0 20px;margin: 10px 0;border-right: 1px solid white;">
          <div><span style="font-size: 20px;">{{ data.days }}</span>天</div>
          <div style="font-size: 14px;">合同天数</div>
        </div>
        <div style="padding: 0 20px;margin: 10px 0;">
          <div><span style="font-size: 20px;">{{ data.amount }}</span>元</div>
          <div style="font-size: 14px;">租金金额</div>
        </div>
      </div>
      <van-cell-group inset style="margin-top: 10px;">
        <van-cell title="合同起始时间" :value="dataInfo"/>
        <van-cell title="合同签订时间" :value="data.signingDate"/>
      </van-cell-group>

    </div>

    <div
        style="font-size: 18px; margin-top: 230px;padding-left: 20px;font-weight: 550; background-color: white;padding-bottom: 20px;">
      <div v-for="(x,index) in inputForm">
        <van-cell-group>
          <van-cell title="合同编号" label="合同期限" :to="{path: 'shye_contract', query: {id: x.id }}">
            <template #title>
              <span class="custom-title">{{ x.code }}</span>
              <span class="custom-title" v-if="x.bunkName">({{ x.bunkName }})</span>
            </template>
            <template #extra>
              <span class="custom-title">{{ x.amount }}元</span>
              <van-icon name="arrow" style="margin-top: 10px;"/>
            </template>
            <template #label>
              <span
                  class="custom-title">{{ timestampToTime(x.startDate) }}至{{ timestampToTime(x.endDate) }}(共{{ x.days }}天)</span>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>

  </div>
</template>

<script>
import NewContractsService from '@/api/contract/NewContractsService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {log10} from 'core-js/core/number'

export default {
  data() {
    return {
      isshow: false,
      dataInfo: '',
      inputForm: {},
      data: {},
    }
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    // if(!(query.data==="[object Object]")){
    // 	this.data = query.data
    // }
    this.data = query.data
    this.dataInfo = `${this.data.startDate}至${this.data.endDate}`
    this.init()
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init() {
      new NewContractsService().queryByCustomer(this.data.customerId, this.data.id).then(({data}) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
  }
}
</script>

<style>
body {
  background-color: #EFEFEF;
}

.leftText {
  color: #A0A0A0 !important;
}

.van-collapse-item__title .van-cell__title {
  font-size: 18px;
}

.van-cell-group--inset {
  margin: 12px 0;
}

.van-cell-group--inset .van-cell {
  background-color: #F5F6F8;
  line-height: 10px;
}

.van-cell-group .van-cell .van-cell__title, .van-cell-group .van-cell .van-cell__value {
  flex: auto;
}
</style>
